import { Button, ButtonProps } from "@jugl-web/ui-components";
import React from "react";

export const WhatsappPinDialogFooter: React.FC<{
  buttons: (Omit<ButtonProps, "ref" | "className"> & { text: string })[];
}> = ({ buttons }) => (
  <div className="flex h-[77px] shrink-0 items-center justify-end gap-2.5 border-0 border-t border-solid border-[#EEF2F5] px-10 py-6">
    {buttons.map(({ text, ...props }, idx) => (
      <Button className="h-10 px-8" {...props} key={+idx}>
        {text}
      </Button>
    ))}
  </div>
);
